import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import { setDefaultOfForm } from '../../actions/purchaseOrders_actions';
import { fetchSalesPerformance, printSP } from '../../actions/sales_actions';
import { 
  fetchGroups, fetchGroupCategories, fetchDeps, fetchDepCategories, fetchPackageTypes
} from '../../actions/products_actions';
import {
  fetchSalesPerformanceByFilter, fetchUserPerformanceByFilter, fetchStores 
} from '../../actions/salesPerformanceList_actions';
import { fetchBaseUsers, resetCurrentUser, fetchMobileUsers } from '../../actions/settings_actions';
import { fetchActiveCustomers } from '../../actions/customers_actions';
import SalesPerformance from '../../components/Sales/salesPerformance';

const salesPerformance = reduxForm({
  form: 'salesPerformance',
})(SalesPerformance);


const selector = formValueSelector('salesPerformance');

function mapStateToProps(state) {
  const Days = selector(state, 'Days');
  const FromDate = selector(state, 'FromDate');
  const ToDate = selector(state, 'ToDate');
  const userDays = selector(state, 'userDays');
  const userTimeSelection = selector(state, 'userTimeSelection');
  const userFromDate = selector(state, 'userFromDate');
  const userToDate = selector(state, 'userToDate');
  const Aggregate = selector(state, 'Aggregate');
  const SalesType = selector(state, 'SalesType');
  const ProductNum = selector(state, 'ProductNum');
  const User = selector(state, 'User');
  const Seller = selector(state, 'Seller');
  const Customer = selector(state, 'Customer');
  const Store = selector(state, 'Store');

  return {
    Store,
    Days,
    FromDate,
    ToDate,
    Aggregate,
    SalesType,
    ProductNum,
    User,
    userDays,
    userTimeSelection,
    userFromDate,
    userToDate,
    Seller,
    Customer,
    groups: state.products.groups,
    deps: state.products.deps,

    groupCategories: state.products.groupCategories,
    salesPerformanceIsLoading: state.salesOrders.salesPerformanceIsLoading,
    salesPerformance: state.salesOrders.salesPerformance,
    salesPerformanceError: state.salesOrders.salesPerformanceError,
    users: state.settings.all,
    customers: state.customers.all,
    customersIsLoading: state.customers.isLoading,
    mobileUsers: state.settings.all,
    isLoading: state.settings.isLoading,
    userPerformanceIsLoading: state.salesOrders.userPerformanceIsLoading,
    userPerformanceData: state.salesOrders.userPerformanceData,
    userPerformanceError: state.salesOrders.userPerformanceError,

    spPDF: state.salesOrders.spPDF,
    selectedCompany: state.header.selectedCompany,
    selectedWarehouse: state.header.selectedWarehouse,
    stores: state.salesOrders.stores,
    packageTypesFetched: state.products.packageTypesFetched, // pkg type
  };
}

export default connect(mapStateToProps, {
  fetchDeps,
  fetchDepCategories,
  fetchSalesPerformanceByFilter,
  fetchSalesPerformance,
  printSP,
  setDefaultOfForm,
  fetchGroups,
  fetchGroupCategories,
  fetchBaseUsers,
  fetchMobileUsers,
  resetCurrentUser,
  fetchActiveCustomers,
  fetchUserPerformanceByFilter,
  fetchStores,
  fetchPackageTypes,
})(salesPerformance);



// WEBPACK FOOTER //
// ./master/jsx/containers/Sales/salesPerformance.jsx